import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import box1 from "../../assets/box/box1";
import box2 from "../../assets/box/box2";
import box3 from "../../assets/box/box3";
import boxDefault from "../../assets/box/default";
import { replaceCssVarInvocations } from "../selectors/util/variantStyles";

const boxVariantAdapter = createEntityAdapter({});

const builtInBoxes = [boxDefault, box1, box2, box3];

const initialState = boxVariantAdapter.addMany(
  boxVariantAdapter.getInitialState({
    currentBoxVariant: "default",
    textColor: "#000000",
    backgroundColor: "#ffffff",
  }),
  builtInBoxes
);

const sliceName = "boxVariant";

const boxVariantSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setCurrentBoxVariant(state, action) {
      state.currentBoxVariant = action.payload;
    },
    setBoxTextColor(state, action) {
      state.textColor = action.payload;
    },
    setBoxBackgroundColor(state, action) {
      state.backgroundColor = action.payload;
    },
  },
});

export const { setCurrentBoxVariant, setBoxTextColor, setBoxBackgroundColor } =
  boxVariantSlice.actions;
export default boxVariantSlice.reducer;

const selectors = boxVariantAdapter.getSelectors();
export const globalizedBoxVariantSelectors = boxVariantAdapter.getSelectors(
  (state) => state[sliceName]
);

export const getBoxCss = (state, { variant }) => {
  let css = selectors.selectById(state, variant)?.css;
  if (css) {
    const varExpression = (v) => `--${boxVariantNameToCssClass(variant)}-${v}`;
    const cssVarNameValueObject = {
      [varExpression("textColor")]: getBoxTextColor(state),
      [varExpression("backgroundColor")]: getBoxBackgroundColor(state),
    };
    css = replaceCssVarInvocations(cssVarNameValueObject, css);
  }
  return css;
};

export const getCurrentBoxVariant = (state) => state.currentBoxVariant;
export const getBoxTextColor = (state) => state.textColor;
export const getBoxBackgroundColor = (state) => state.backgroundColor;

export const boxVariantNameToCssClass = (name) => `sirv-box-variant-${name}`;

export const getBoxVariantCssClassName = (state, options) => {
  const boxVariant = getCurrentBoxVariant(state);
  if (!boxVariant) {
    return "";
  }
  const className = boxVariantNameToCssClass(boxVariant);
  return className;
};

export const getBoxStyleTag = (state, options = {}) => {
  const { variant = getCurrentBoxVariant(state) } = options;
  const boxCss = getBoxCss(state, { variant });
  const boxStyleTag = boxCss ? `<style>${boxCss}</style>` : "";
  return boxStyleTag;
};
